import { withStyles } from '@material-ui/core';

import PaperSheet from './component';
import styles from './styles';

export default withStyles(styles)(PaperSheet);
